export default "__VITE_ASSET__BGa1U8h8__"